var $ = require('jquery');

web = window.web = window.web || {};

    web.ParamResolver = module.exports = function(options) {
        var t = this;
        t.instanceState = 'constructed';

        t.params = {};
        t.onParams = [];

        t.options = $.extend({}, t.defaults, options);
    };

    web.ParamResolver.prototype = {
        init:  function(){
            var t = this;
            t.instanceState = 'inicialized';

            t.params = t._getUrlVars();

        },

        refreshParams: function(){
            var t = this;

            t.params = t._getUrlVars();;
        },

        setParamEvent: function(param, callback){
            var t = this;
            t.onParams[param] = function(){
                callback(t.params[param], t.params);
            }
        },

        executeParamsResolving: function(){
            var t = this;

            for (var index in t.params) {
                if (typeof t.onParams[index] == 'function') {
                    t.onParams[index](t.params[index], t.params);
                }
            }

            t.instanceState = 'resolvingExecuted';

        },

        _getUrlVars: function(){
            var result = {};
            var href = window.location.href;
            // if (location.hash) {
            // href = href.substring(0, (href.length - location.hash.length));
            // }

            href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
                if (value.indexOf("#")!=-1) {
                    value=value.substring(0,value.indexOf("#"));
                }
                result[key] = decodeURIComponent(value);
            });
            return result;
        },

        getParams: function(){
            var t = this;

            return t.params || {};
        }


    }



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/ParamResolver.js